import React from 'react';
import RenderConfiguration from '../SVG';
import optimizeIcon from './svg/optimize.svg';
export default class Helper extends React.Component {
  render() {
    const {
      configuration,
      rack,
      uxPath,
      bikeConfiguration,
      marginAdds,
      width,
      length,
      handleScrollIn,
      handleScrollOut,
      pastWidth,
      pastLength
    } = this.props;

    return marginAdds ? (
      <div
        className='explainer-text'
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          zIndex: 1,
          ...this.props.style
        }}
      >
        <img src={optimizeIcon} />
        {marginAdds.width.count ? (
          <div className='margin-add'>
            <span>
              Increasing the room width by{' '}
              <button
                className='increase-room'
                onClick={() => {
                  this.props.actions.parameterWidth(
                    width + marginAdds.width.width
                  );
                }}
                style={{ display: 'inline' }}
              >
                {marginAdds.width.width}
                ft
              </button>{' '}
              will result in <strong>{marginAdds.width.count}</strong> more
              bikes.
              {pastWidth.length ? (
                <button
                  className='increase-room'
                  style={{
                    opacity: 0.7,
                    position: 'absolute',
                    right: '-60px'
                  }}
                  onClick={() => this.props.actions.undoWidth()}
                >
                  Undo
                </button>
              ) : null}
            </span>
          </div>
        ) : null}
        {marginAdds.length.count ? (
          <div className='margin-add' style={{ paddingBottom: '20px' }}>
            <span>
              Increasing the room length by{' '}
              <button
                className='increase-room'
                onClick={() => {
                  this.props.actions.parameterLength(
                    length + marginAdds.length.length
                  );
                }}
              >
                {marginAdds.length.length}
                ft
              </button>{' '}
              will result in <strong>{marginAdds.length.count}</strong> more
              bikes.
              {pastLength.length ? (
                <button
                  className='increase-room'
                  style={{ opacity: 0.7, position: 'absolute', right: '-60px' }}
                  onClick={() => this.props.actions.undoLength()}
                >
                  Undo
                </button>
              ) : null}
            </span>
          </div>
        ) : null}
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Configuration/Render/Helper/index.js